// React Bootstrap components
import { Card } from "react-bootstrap";

// Components
import TabCardHeader from "../../../ui/TabCardHeader";
import FinanceSkupniPodatkiRealizirano from "./FinanceSkupniPodatkiRealizirano";
import FinanceClaniceRealiziranoCards from "./FinanceClaniceRealiziranoCards";
import AccessDenied from "../../../ui/AccessDenied";

// Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";
import useRoleCheck from "../../../../auth/useRoleCheck";
import useClanicaCheck from "../../../../auth/useClanicaCheck";

// Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const RealiziranaVrednostProjekta = () => {
  const { project } = useProjectDetailsContext();
  const { isEditor, isFakultetniSkrbnik } = useRoleCheck(MODULES.PROJEKTI);

  const { isUserClanicaInList } = useClanicaCheck(null, project?.clanice ?? []);

  // Editor always sees clanice; fakultetni skrbnik only if their clanica is on this project
  const canViewClaniceFinance =
    isEditor || (isFakultetniSkrbnik && isUserClanicaInList);

  return (
    <RoleGuard
      moduleKey={MODULES.PROJEKTI}
      roles={ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI}
      fallback={<AccessDenied />}
    >
      <Card className="mb-4">
        <TabCardHeader
          title="Realizirana vrednost projekta"
          showEditButton={false}
        />
        <div className="px-4 pt-4 pb-2">
          <FinanceSkupniPodatkiRealizirano />
          {canViewClaniceFinance && (
            <>
              <hr className="form-section-divider" />
              <FinanceClaniceRealiziranoCards />
            </>
          )}
        </div>
      </Card>
    </RoleGuard>
  );
};

export default RealiziranaVrednostProjekta;
